import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
const _c0 = ["ycn-flattened-holding-item", ""];
const _c1 = a0 => ({ "bg-panel": a0 });
const _c2 = a0 => ({ collapsed: a0 });
function FlattenedHoldingItemComponent_td_1_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td")(1, "div", 6)(2, "div", 7);
    i0.ɵɵlistener("click", function FlattenedHoldingItemComponent_td_1_Template_div_click_2_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.toggleShowAttributions()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "a", 8);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c2, !ctx_r1.showAttributions));
    i0.ɵɵadvance();
    i0.ɵɵproperty("href", ctx_r1.holding.url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.holding.ticker);
} }
function FlattenedHoldingItemComponent_td_2_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td")(1, "div", 6)(2, "div", 7);
    i0.ɵɵlistener("click", function FlattenedHoldingItemComponent_td_2_Template_div_click_2_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.toggleShowAttributions()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4, "--");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c2, !ctx_r1.showAttributions));
} }
function FlattenedHoldingItemComponent_tr_8_tr_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td", 13)(2, "div", 14);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "td", 15);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(8, "td", 15)(9, "td", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const attribution_r4 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(attribution_r4.ticker);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(attribution_r4.name);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(attribution_r4.weight);
} }
function FlattenedHoldingItemComponent_tr_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 9)(1, "td", 10)(2, "table", 11)(3, "tbody");
    i0.ɵɵtemplate(4, FlattenedHoldingItemComponent_tr_8_tr_4_Template, 10, 3, "tr", 12);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r1.holding.attributions);
} }
/**
 * FlattenedHoldingItemComponent
 *     Represents one row of the FlattenedHoldingsTable
 *
 * Required Attributes:
 *      @holding: The formatted flattened holding to display in the table row
 *
 * Optional Attributes:
 *      @fillRowBackgroud: Whether the row's background color is light gray ($panel-background : #f7f8f8;).
 *                         for the 'table-striped' effect, this should be true only for even indexed rows.
 */
export class FlattenedHoldingItemComponent {
    constructor() {
        this.fillRowBackground = false;
        this.showAttributions = false;
    }
    toggleShowAttributions() {
        this.showAttributions = !this.showAttributions;
    }
}
FlattenedHoldingItemComponent.ɵfac = function FlattenedHoldingItemComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FlattenedHoldingItemComponent)(); };
FlattenedHoldingItemComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FlattenedHoldingItemComponent, selectors: [["", "ycn-flattened-holding-item", ""]], inputs: { holding: "holding", fillRowBackground: "fillRowBackground" }, standalone: false, attrs: _c0, decls: 9, vars: 12, consts: [[3, "ngClass"], [4, "ngIf"], [3, "textContent"], [1, "text-right", 3, "textContent"], [1, "text-right"], ["class", "tr-collapse-body", 4, "ngIf"], [1, "relative", "pl-20"], [1, "collapse-mark", 3, "click", "ngClass"], [3, "href"], [1, "tr-collapse-body"], ["colspan", "99", 1, "td-details"], [1, "table"], [4, "ngFor", "ngForOf"], [1, "colTxtMed"], [1, "pl-20"], [1, "colTxtShort", "text-right"]], template: function FlattenedHoldingItemComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "tr", 0);
        i0.ɵɵtemplate(1, FlattenedHoldingItemComponent_td_1_Template, 5, 5, "td", 1)(2, FlattenedHoldingItemComponent_td_2_Template, 5, 3, "td", 1);
        i0.ɵɵelement(3, "td", 2)(4, "td", 3)(5, "td", 3);
        i0.ɵɵelementStart(6, "td", 4);
        i0.ɵɵelement(7, "strong", 2);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(8, FlattenedHoldingItemComponent_tr_8_Template, 5, 1, "tr", 5);
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c1, ctx.fillRowBackground));
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.holding.url);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.holding.url);
        i0.ɵɵadvance();
        i0.ɵɵproperty("textContent", ctx.holding.name);
        i0.ɵɵadvance();
        i0.ɵɵproperty("textContent", ctx.holding.current_weight);
        i0.ɵɵadvance();
        i0.ɵɵproperty("textContent", ctx.holding.latest_quote);
        i0.ɵɵadvance(2);
        i0.ɵɵclassMap(ctx.holding.change_percent_display == null ? null : ctx.holding.change_percent_display.cssClass);
        i0.ɵɵproperty("textContent", ctx.holding.change_percent_display == null ? null : ctx.holding.change_percent_display.value);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.showAttributions);
    } }, dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf], encapsulation: 2 });
